<template>
	<div>
		<ConnectionMappingTitle
			class="mb-1"
			:serviceId="serviceId"
			:credentialsData="credentialsData"
			:configurationType="configurationType"
			:overrideSelectProfile="overrideSelectProfile"
			:credentialSelectorFields="credentialSelectorFields"
		/>
		<div class="field-container width-100">
			<div class="header-container display-flex flex-row flex-align-center px-3">
				<SIcon name="setup" width="14" class="mr-2 mt-1" />
				This is a block in {{ configurationType }} setup
			</div>
			<WidgetFieldWrapper
				v-if="field"
				class="px-3"
				:field="field"
				:ignoreRequired="true"
				:hideExplanation="true"
				@update-value="updateValue"
				:fieldValue="fieldResponse"
				:narrowLayout="narrowLayout"
				:isGeneralConfiguration="configurationType === 'general'"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	getConfigurationInterface,
	getConfigurationFieldResponse,
	getConfigurationFieldsIdsPerInterface,
} from '@/store/modules/workflowConfigurations/getters';
import WidgetFieldWrapper from '@/components/WidgetForm/WidgetFieldWrapper.vue';
import WorkflowConfigurationService from '@/utils/workflow-configuration-service';
import { saveConfigurationFieldResponse } from '@/store/modules/workflowConfigurations/actions';
import ConnectionMappingTitle from '@/components/common/ProfileSelector/ConnectionMappingTitle.vue';
export default {
	name: 'ConfigurationField',
	props: {
		serviceId: { type: Number },
		fieldUUID: { type: String },
		narrowLayout: { type: Boolean },
		credentialsData: { type: Object },
		configurationId: { type: Number },
		credentialsType: { type: String },
		configurationType: { type: String },
		overrideSelectProfile: { type: Function },
		credentialSelectorFields: { type: Array },
	},
	components: { WidgetFieldWrapper, ConnectionMappingTitle },
	computed: {
		...mapGetters([
			getConfigurationInterface.fullPath,
			getConfigurationFieldResponse.fullPath,
			getConfigurationFieldsIdsPerInterface.fullPath,
		]),
		configurationInterfaceUUID() {
			return WorkflowConfigurationService.getConfigurationInterfaceFromField(
				this.configurationId,
				this.fieldUUID,
				this[getConfigurationFieldsIdsPerInterface.fullPath]
			);
		},
		fieldResponse() {
			return this[getConfigurationFieldResponse.fullPath](this.configurationId, this.fieldUUID);
		},
		configurationInterface() {
			return this[getConfigurationInterface.fullPath](this.configurationId, this.configurationInterfaceUUID);
		},
		field() {
			return this.configurationInterface?.fields.find((field) => field.id === this.fieldUUID);
		},
	},
	methods: {
		...mapActions([saveConfigurationFieldResponse.fullPath]),
		async updateValue({ value }) {
			await this[saveConfigurationFieldResponse.fullPath]({
				id: this.configurationId,
				interfaceUUID: this.configurationInterfaceUUID,
				fieldUUID: this.fieldUUID,
				response: value,
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.field-container {
	min-height: 105px;
	border-radius: 10px;
	background: var(--bg-color);
	border: 1px solid var(--border-color);
}
.header-container {
	font-size: 12px;
	color: #8c95a1;
	font-weight: medium;

	height: 30px;
	border-radius: 10px 10px 0px 0px;
	border-bottom: 1px solid var(--border-color);
	background: var(--setup-node-container-background);
}
</style>
